export default "__VITE_ASSET__DX6i1P43__"